import { I18nProvider, useI18n } from './i18n/I18nProvider'
import { Footer, Hero, TopBar } from './components/sections/Chrome'
import { Faq, HowItWorks, Practice, Security } from './components/sections/Sections'
import { GeneratorCard } from './components/generator/GeneratorCard'

function Page() {
  const { t } = useI18n()
  return (
    <>
      <a
        href="#gerador"
        className="sr-only focus:not-sr-only focus:absolute focus:top-3 focus:left-3 focus:z-50 focus:rounded-xl focus:bg-surface focus:px-4 focus:py-2 focus:text-sm focus:shadow-lift"
      >
        {t.topbar.skip}
      </a>

      <TopBar />

      <div className="mx-auto w-full max-w-5xl px-4">
        <main>
          <Hero />
          <GeneratorCard />
          <HowItWorks />
          <Security />
          <Practice />
          <Faq />
        </main>
        <Footer />
      </div>
    </>
  )
}

export function App() {
  return (
    <I18nProvider>
      <Page />
    </I18nProvider>
  )
}
